/**
* Scroll To
*/

class ScrollTo {
  constructor() {
    // Scroll To
    function scrollTo() {
      $('.js-scroll-to').on('click', function(e) {
        e.preventDefault();

        let target = $(this).attr('href');

        $('html, body').animate({
          scrollTop: $(target).offset().top
        }, 1500);
      });
    }

    // Scroll Header
    function scrollHeader() {
      const scrollPos = window.pageYOffset;

      const header = $('#header');
      const headerToggle = $('#toggle');

      if (scrollPos > 100) {
        header.addClass('-scroll');
        headerToggle.addClass('-scroll');
      } else {
        header.removeClass('-scroll');
        headerToggle.removeClass('-scroll');
      }
    }

    $(window).scroll(scrollHeader);
    scrollTo();

  }

}

export default ScrollTo;

